/* eslint-disable @typescript-eslint/naming-convention */
export enum EngagementAgeEnum {
    latest = 'latest',
    ingestion = 'ingestion',
    one_hour = 'one_hour',
    eight_hour = 'eight_hour',
    one_day = 'one_day',
    two_days = 'two_days',
    seven_days = 'seven_days',
    thirty_days = 'thirty_days'
}
